{
  "nav": {
    "dashboard": "Workbench",
    "aiChat": "AI Chat",
    "invoices": "Close-out & Invoices",
    "bookkeeping": "Bookkeeping",
    "clients": "Customers",
    "groupClass": "CLASSES",
    "groupFinance": "FINANCE",
    "aiAssistant": "AI Assistant",
    "mainNav": "Main navigation",
    "toggleSidebar": "Toggle sidebar",
    "tab": {
      "today": "Today",
      "classes": "Classes",
      "students": "Students",
      "invoices": "Invoices",
      "more": "More",
      "moreDescription": "More navigation and account options"
    }
  },
  "install": {
    "item": "Install app to home screen",
    "helpTitle": "Install LopHoc to your home screen",
    "helpIntro": "On iPhone/iPad, Safari does not let apps open an install prompt — two steps:",
    "helpStep1": "Tap the Share button (square with an arrow) in Safari's bottom bar.",
    "helpStep2": "Choose \"Add to Home Screen\", then tap Add."
  },
  "branch": {
    "all": "All branches",
    "label": "Branch",
    "trigger": "Choose a branch",
    "unassigned": "No branch yet",
    "manage": "Manage branches",
    "menuHint": "Choose the branch scope for the whole app.",
    "clear": "All"
  },
  "orgMenu": {
    "trigger": "Organisation menu",
    "role": {
      "OWNER": "OWNER",
      "ADMIN": "ADMIN",
      "MEMBER": "TEACHER"
    },
    "planLine": {
      "auto": "{{plan}} plan · auto-reconcile on",
      "noBank": "{{plan}} plan · no bank linked",
      "plain": "{{plan}} plan"
    },
    "planFree": "Free",
    "accountGroup": "Account — {{name}}",
    "switchOrg": "Switch organisation",
    "hint": {
      "members": "includes teacher pay rates"
    }
  },
  "brand": {
    "name": "LopHoc.app",
    "plan": "PRO"
  },
  "user": {
    "logout": "Log out"
  },
  "aiCredits": {
    "label": "AI credits this month"
  },
  "reconcile": {
    "label": "Reconcile"
  },
  "loading": "Loading...",
  "saving": "Saving...",
  "cancel": "Cancel",
  "save": "Save",
  "delete": "Delete",
  "edit": "Edit",
  "back": "Back",
  "next": "Next",
  "skip": "Skip",
  "finish": "Finish",
  "create": "Create",
  "view": "View",
  "send": "Send",
  "close": "Close",
  "copy": "Copy",
  "download": "Download",
  "actions": "Actions",
  "moreActions": "More actions",
  "confirm": "Confirm",
  "roles": {
    "OWNER": "Owner",
    "ADMIN": "Admin",
    "MEMBER": "Member"
  },
  "empty": {
    "filterBody": "Try changing the status or picking a different month.",
    "clearFilters": "Clear filters",
    "searchTitle": "No results for “{{query}}”",
    "searchHint": "Search by name or nickname — no need to type accents."
  },
  "picker": {
    "selectDate": "Select date",
    "selectMonth": "Select month",
    "clear": "Clear",
    "prevYear": "Previous year",
    "nextYear": "Next year"
  },
  "rbac": {
    "adminOnly": "Admins only"
  },
  "dashboardPage": {
    "title": "Dashboard Overview",
    "welcome": "Welcome back. Here is your business at a glance."
  },
  "help": {
    "item": "Help & feedback",
    "itemShort": "Help",
    "title": "Help & feedback",
    "subtitle": "A bug, an idea, or a question — sent straight to the LopHoc team.",
    "kind": {
      "bug": "Report a bug",
      "feature": "Suggest a feature",
      "question": "Ask a question"
    },
    "placeholder": "What happened, or what should LopHoc do better for you?",
    "messageLabel": "Your message",
    "send": "Send",
    "sending": "Sending...",
    "sent": "Sent — thank you.",
    "tooFast": "That was quick — try again in a few minutes.",
    "error": "Couldn't send that. Try again, or message us on Zalo below.",
    "contactTitle": "Contact & guide",
    "guide": "User guide",
    "invite": "Send a question any time."
  },
  "copyright": "© 2026 LopHoc.app. All rights reserved.",
  "notFound": {
    "title": "Page not found",
    "body": "This URL does not exist — it may be a typo, or the page may have moved.",
    "cta": "Back to home"
  },
  "routeError": {
    "title": "Something went wrong",
    "body": "The app hit a problem opening this page. Try reloading; if it persists, send us a message.",
    "retry": "Reload"
  },
  "impersonation": {
    "viewingAs": "Viewing as {{name}} — {{org}}",
    "readOnly": "read-only mode",
    "exit": "Exit",
    "popover": {
      "title": "This session cannot write anything",
      "writes": "Viewing works normally. Every save, create, edit, or delete is refused by the server — clicking it shows an error rather than silently doing nothing.",
      "pages": "A few pages need to write in order to build their content, most notably Settings · Bank, so opening them shows an error. That is expected, not broken.",
      "sessions": "The Workbench's session list can also come up shorter than reality: weeks the teacher hasn't opened yet haven't been generated, and generating them is itself a write, so it's blocked — with no error shown.",
      "expiry": "The session expires on its own after 30 minutes, with no renewal.",
      "audit": "The teacher sees nothing unusual. Every impersonation is recorded in the system audit log."
    }
  }
}
